define('modules/start/products/landings/status/view',['require','exports','module','env','views/BaseView','ldsh!./template'],function(require, exports, module) {
    "use strict";

    var Config = require('env');
    var BaseView = require('views/BaseView');

    var Layout = BaseView.extend({
        template: require('ldsh!./template'),

        events: {},

        initialize: function() {
            if(this.productDetails) {
                this.listenTo(this.productDetails, 'sync', this.render);
            }
        },

        serialize: function() {
            return {
                productDetails: this.productDetails,
                servicePlan: this.productDetails.get('type'),
                trialDays: this.productDetails.getTrialDays(),
                paymentsUrl: Config.paymentsUrl + 'account/products',
            };
        }
    });

    module.exports = Layout;
});

